import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Fetches manual reviews + imported Google reviews and merges them.
// Aggregate rating/count uses Google's official figures when available.
export function useReviews() {
  const [manual, setManual] = useState([]);
  const [google, setGoogle] = useState({ available: false, rating: null, total: 0, reviews: [] });

  useEffect(() => {
    api.get("/reviews").then(({ data }) => setManual(data)).catch(() => {});
    api.get("/reviews/google").then(({ data }) => setGoogle(data)).catch(() => {});
  }, []);

  const reviews = [...(google.reviews || []), ...manual];
  const manualAvg = manual.length ? manual.reduce((s, r) => s + (r.rating || 0), 0) / manual.length : 0;

  const avg = google.available && google.rating ? google.rating : manualAvg;
  const total = google.available && google.total ? google.total : manual.length;

  // Direct "write a review" link when the Place ID is known, else a Maps search
  // that lands on the garage listing where the visitor can leave a review.
  const writeReviewUrl = google.write_review_url ||
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("Garage Ter Spelt, Koeweidestraat 47 C, 1785 Merchtem");

  return { reviews, avg, total, googleAvailable: google.available, hasAny: reviews.length > 0, writeReviewUrl };
}
